import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";

const icaBaseController = "api/corp-member"

export const getAllRegisteredCmIcaApi = async (body = {}) => {
  const urlParams = generalFunc.generateUrlParams(body)
  try {
    if (navigator.onLine) {
      const response = await api.get(`${icaBaseController}/get-all-CmInCampTraining${urlParams}`)
      return response.data;
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message)
    throw error;
  }
}

export const getCmIcaByIdApi = async (CmInCampTrainingId) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${icaBaseController}/get-cmincamptraining-byId/${CmInCampTrainingId}`);
      return response.data;
    } else {
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message);
    throw error;
  }
}

export const exportCmTrainingApi = async () => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // toastr.info("Downloading...", "Pending");
    await api
      .get(`${icaBaseController}/export-CmInCampTraining`, { responseType: "blob" })
      .then((response) => {
        // toastr.info("Downloading...");
        if (typeof response !== "undefined") {
          if (response.status === 200 || response.status === 204) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `SAED Trainers ${generalFunc.getCurrentYear()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            toastr.clean();
            toastr.success("Download Trainers SpreadSheet", "Success");
          } else {
            toastr.clean();
            toastr.error(
              "Download Trainers SpreadSheet",
              "Error in fetching API"
            );

          }
        }
      })
      .catch((ex) => {
        console.log(ex, "Error")
        toastr.clean();
        toastr.error("An Error occured", "Please try again");
      });
  }
};

export const getAllIcaNoPaginationApi = async (body = {}) => {
  const urlParams = generalFunc.generateUrlParams(body)
  try {
    if (navigator.onLine) {
      const response = await api.get(`${icaBaseController}/get-all-CmInCampTraining-no-pagination/${urlParams}`);
      return response.data;
    } else {
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message);
    throw error;
  }
}